<template>
    <CalendarGridRow
        :class="cn(props.class)"
        v-bind="forwardedProps"
    >
        <slot />
    </CalendarGridRow>
</template>

<script setup lang="ts">
import type { CalendarGridRowProps } from 'reka-ui';
import type { HTMLAttributes } from 'vue';
import { reactiveOmit } from '@vueuse/core';
import { CalendarGridRow, useForwardProps } from 'reka-ui';
import { cn } from '@/lib/utils';

const props = defineProps<CalendarGridRowProps & { class?: HTMLAttributes['class'] }>();

const delegatedProps = reactiveOmit(props, 'class');

const forwardedProps = useForwardProps(delegatedProps);
</script>
